var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7722 3.33889C14.0759 3.64263 14.0759 4.13509 13.7722 4.43883L7.54997 10.6611C7.24623 10.9648 6.75377 10.9648 6.45003 10.6611L0.227806 4.43883C-0.0759344 4.13509 -0.0759344 3.64263 0.227806 3.33889C0.531547 3.03515 1.02401 3.03515 1.32775 3.33889L7 9.01114L12.6723 3.33889C12.976 3.03515 13.4685 3.03515 13.7722 3.33889Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronIcon);
export default __webpack_public_path__ + "static/media/chevron_icon.1702efe99c97aae3ffc45f52665c91c4.svg";
export { ForwardRef as ReactComponent };